/* global APP_URL */

import axios from 'axios';
import _ from 'lodash';
import { addressAbbreviationsDictionary } from './street_abbreviations';

export const isNotNull = (x) => x !== null;
export const isNotUndefined = (x) => x !== undefined;
export const isNotEmptyString = (x) => x !== '';
export const isEmptyString = (x) => !isNotEmptyString(x);
export const isFalse = (x) => x === false || x === 'false' || x === 0;
export const isNotFalse = (x) => !(isFalse(x));
export const isOff = (x) => isFalse(x) || x === 'off';
export const isTrue = (x) => x === true || x === 'true' || x === 1;
export const isNotTrue = (x) => !isTrue(x);
export const isOn = (x) => isTrue(x) || x === 'on';

const currentYear = new Date().getFullYear();
const currentYearLast2digits = currentYear - 2000;
const lastYearLast2digits = currentYearLast2digits - 1;
const nextYearLast2digits = currentYearLast2digits + 1;
const yearAfterNextYearLast2digits = nextYearLast2digits + 1;
const lastYear = currentYear - 1;
const nextYear = currentYear + 1;
const yearAfterNext = nextYear + 1;
const yearAfterNextAfter = nextYear + 2;
const yearAfterNextAfterNextAfter = nextYear + 3;

export const writeToView = (variableToWrite, DescriptionForIt = 'outputting variable', elementId = 'availability_message') => {
  const orangeSquare = document.getElementById(elementId);
  orangeSquare.innerHTML += `!!! ${DescriptionForIt} ${variableToWrite} \n`;
  // console.log(`!!! ${DescriptionForIt} ${variableToWrite}`);
};
/**
 * Checks that is not Null nor Undefined
 */
export const isNotNU = (x) => isNotNull(x) && isNotUndefined(x);
/**
 * Checks if it is Null or Undefined
 */
export const isNU = (x) => !isNotNull(x) || !isNotUndefined(x);
/**
 * Checks that is not Null nor Undefined nor Empty String
 */
export const isNotNUES = (x) => isNotNU(x) && isNotEmptyString(x);
/**
 * Checks that is not Null nor Undefined nor false
 */
export const isNotNUF = (x) => isNotNU(x) && isNotFalse(x);

export const isDev = () => (APP_URL === 'https://pbc2017.pbndev.net' || APP_URL === 'https://pbc2017.localhost' || APP_URL === 'https://web.test');
export const focus = (id) => {
  setTimeout(() => { document.getElementById(id).scrollIntoView(); }, 200);
};
export const ifIsDevConsoleLog = (outputThis, phrase = '') => {
  if (isDev()) {
    if (phrase !== '') {
      // eslint-disable-next-line no-console
      console.log(`${phrase} start`);
      // eslint-disable-next-line no-console
      console.log(outputThis);
      // eslint-disable-next-line no-console
      console.log(`${phrase} end`);
    } else {
      // eslint-disable-next-line no-console
      console.log(outputThis);
    }
  }
};
export const valueIsNotEmpty = (value) => value && value.trim() !== '' && value.trim() !== [];
// return value !== '' && value !== undefined && value !== null;

export const focusOnId = (id) => document.getElementById(id).focus();
export const focusOnClass = (aClass) => {
  const theClass = document.getElementsByClassName(aClass);
  theClass[0].focus();
};

export const inCaseOfEventPreventDefault = (event = false) => {
  if (event && typeof event === 'object') {
    event.preventDefault();
  }
  // do nothing. Although there is a `prevent` on input. The input sometimes is still pushing the trigger
};
export const scapeHTMLCode = (str) => _.escape(str).trim();

export const getReferrer = (known = '') => {
  const prevUrl = document.referrer;
  if (prevUrl === null || prevUrl === undefined) {
    if (window.location.href !== null && window.location.href !== undefined) {
      if (known === '') {
        return `${window.location.href}`;
      }
      return `${known} -> ${window.location.href}`;
    }
    return `${known}`;
  }
  if (known === '') {
    return `${prevUrl}`;
  }
  return `${known} -> ${prevUrl}`;
};

export const axiosGet = async (url) => {
  const response = await axios.get(url);
  return response.data;
};
export const isItANumber = (x) => !Number.isNaN(x);
export const isAvailable = (availabilityCheck) => {
  let availability;
  if (availabilityCheck !== undefined
    && availabilityCheck !== null
    && availabilityCheck !== []
    && availabilityCheck !== {}) {
    availability = `${availabilityCheck}`.toUpperCase();
  }
  // ifIsDevConsoleLog([availabilityCheck, availability], '[availabilityCheck,availability] isAvailable availabilityCheck');
  availability += ''; // in case a number is returned
  // ifIsDevConsoleLog([availabilityCheck, availability], '[availabilityCheck,availability] isAvailable availabilityCheck');
  return (
    availability === 'AVAILABLE'
    || availability === 'ACTIVE'
      || availability === 'AVAILABE'
      || availability === 'AVAILALBE'
      || availability === 'AVAILBLE'
      || availability === 'AVIABLE'
      || availability === 'AVIALBE'
      || availability === 'AVILABE'
      || availability === 'ACTVIE'
      || availability === 'ACTIEV'
      || availability === 'ACTIV'
  );
};
export const returnAllExceptWord = (key, word) => {
  const k = `${key}`.toUpperCase();
  const w = `${word}`.toUpperCase();
  if (k.includes(w)) {
    let additionalMessage = k.replace(` ${w}`, '');
    additionalMessage = additionalMessage.replace(`${w} `, '');
    additionalMessage = additionalMessage.replace(w, '').trim();

    return additionalMessage;
  }
  return key;
};
export const beforeMay = () => {
  const date = new Date();
  // ifIsDevConsoleLog('> date date date date date date date date date date date date date date date ');
  // ifIsDevConsoleLog(date);
  // ifIsDevConsoleLog(date.getMonth());
  // ifIsDevConsoleLog('< date date date date date date date date date date date date date date date ');
  return (date.getMonth() + 1) < 5;
};
export const afterMayThisYear = (availability) => {
  const key1 = availability === undefined ? 'OTHER' : availability.toUpperCase();
  const number = parseInt(key1, 10);
  // previous year day and after may?
  return isItANumber(number)
    && (
      (
        (number === (currentYear - 1))
          || ((!beforeMay()) && (number === (currentYear)))
      )
    );
  // const yearBeforeLastYear = isItANumber(number) && (number < (currentYear - 1));
  // return lastYearButBeforeMay;// || yearBeforeLastYear;
};

export const isPartOfCurrentYearKeyWord = (availabilityCheckSent, word) => {
  const availabilityCheck = `${availabilityCheckSent}`.toUpperCase();
  let promo = false;
  if (availabilityCheck.includes(word)) {
    const year = returnAllExceptWord(availabilityCheck, word).trim();
    const isItAvailable = isAvailable(year);
    if (isItAvailable || year === `${currentYear}` || year === `${lastYear}` || word === 'LEGACY') {
      promo = true;
    }
  }
  return promo;
};
export const isPartOfCurrentYearPromo = (availabilityCheckSent) => isPartOfCurrentYearKeyWord(availabilityCheckSent, 'PROMO');
export const isPartOfCurrentYearLegacy = (availabilityCheckSent) => isPartOfCurrentYearKeyWord(availabilityCheckSent, 'LEGACY');
export const returnGZWillBeComingScript = (year) => `The GigaZone will be coming to your location in ${year}. You will be notified by direct mail and the availability map will be updated when services are available.`;
export const returnInterestScript = (address) => `It appears that the address entered is outside our current service territory and is not in our current expansion plans. If you are interested in having our cooperative expand to your area in the future, please click the button below and fill out our Interest in Expansion Form. <br/><a class="btn btn-business padding-x-large padding-y-sm my-4" href="/gigazone/interest-in-expansion-form/?address=${address}">I Would Like Paul Bunyan Communications to Expand to My Area</a><br/><em>If you believe that the address entered is in our service territory or in our expansion plans for next year, please call us at 888-586-3100.</em>`;
export const returnFutureScript = () => `It appears that the address entered is designated for future construction. We do not have an estimated construction time currently. You are welcome to check back or contact our office at <a href="tel:888-
586-3100" >888-586-3100</a>.`;
export const returnMessage = (address) => {
  const key_message = address.availability ?? 'OTHER';

  if (key_message === 'expansion form') {
    return address.message;
  }
  let anAddress = '';
  if (address.full_address !== undefined) {
    anAddress = address.full_address;
  } else if (address.fullAddress !== undefined) {
    anAddress = address.fullAddress;
  }

  const expansionMessage = returnInterestScript(anAddress);
  const futureMessage = returnFutureScript();
  const possibleMessages = {
    ACTIVE: 'You are in the GigaZone!',
    AVAILABLE: 'You are in the GigaZone!',
    LEGACY: 'If you would like to sign up for our legacy services (25mbps Down, 3mbps Up), please call us at (218) 444-1234. If you would like to sign up for our legacy services (25mbps Down, 3mbps Up), please call us at (218) 444-1234.',
    FUTURE: futureMessage,
    UNDETERMINED: expansionMessage,
    OTHER: expansionMessage,
    'ADDRESS NOT FOUND': expansionMessage,
    'NOT AVAILABLE': expansionMessage,
    'EXPANSION FORM': expansionMessage,
    // FUTURE: 'While we do anticipate the GigaZone will reach your location, we have not determined when at this point in time. Please check back for further updates.',
    // UNDETERMINED: 'Due to special permitting issues we are not sure if or when the GigaZone may be coming to your location. Check back for further updates.',
    // OTHER: `Your location could be outside of our current service territory or we do not know if or when we will expand to this area. Please verify that your address was entered correctly. ${callUs}`,
    // 'ADDRESS NOT FOUND': `Address not found, please verify that it is entered correctly. If your location is outside of our current service territory. We do not know if or when we expand to this area. ${callUs}`,
  };
  possibleMessages[`${lastYearLast2digits}_${currentYearLast2digits}`] = returnGZWillBeComingScript(`${lastYear}-${currentYear}`);
  possibleMessages[`${currentYearLast2digits}_${nextYearLast2digits}`] = returnGZWillBeComingScript(`${currentYear}-${nextYear}`);
  possibleMessages[`${nextYearLast2digits}_${yearAfterNextYearLast2digits}`] = returnGZWillBeComingScript(`${nextYear}-${yearAfterNext}`);
  possibleMessages[`${lastYear}`] = returnGZWillBeComingScript(`${currentYear}`);
  possibleMessages[`${currentYear}`] = returnGZWillBeComingScript(`${currentYear}`);
  possibleMessages[`${nextYear}`] = returnGZWillBeComingScript(`${nextYear}`);
  possibleMessages[`${yearAfterNext}`] = returnGZWillBeComingScript(`${yearAfterNext}`);
  possibleMessages[`${yearAfterNextAfter}`] = returnGZWillBeComingScript(`${yearAfterNextAfter}`);
  possibleMessages[`${yearAfterNextAfterNextAfter}`] = returnGZWillBeComingScript(`${yearAfterNextAfterNextAfter}`);

  // console.log('key_message', key_message);
  const word1 = key_message.includes('PENDING');
  const word2 = isPartOfCurrentYearPromo(key_message);
  const word3 = isPartOfCurrentYearLegacy(key_message);
  let year = returnAllExceptWord(returnAllExceptWord(returnAllExceptWord(key_message, 'PENDING'), 'PROMO'), 'LEGACY');

  if (possibleMessages[year] === undefined) {
    year = 'NOT AVAILABLE';
  }
  if (word1) {
    return returnGZWillBeComingScript(`${year}`);
  }
  if (word3) {
    return possibleMessages.LEGACY;
  }
  if (isAvailable(year) || word2) {
    return possibleMessages.AVAILABLE;
  }
  const number = parseInt(year, 10);
  const isANumber = isItANumber(number);
  // display following message if the message is showing as last year (till may) or any year before that.
  if ((isANumber && number < currentYear && number > 2019) || (isANumber && number === currentYear && beforeMay())) {
    year = currentYear;
  }
  // ifIsDevConsoleLog(possibleMessages[key1], 'possibleMessages[key1]');
  return possibleMessages[year];
};

export const allArrayCombinations = (arrays) => {
  const numberOfCombinations = arrays.reduce(
    (res, array) => res * array.length,
    1,
  );

  const result = Array(numberOfCombinations)
    .fill(0)
    .map(() => []);

  let repeatEachElement;

  for (let i = 0; i < arrays.length; i++) {
    const array = arrays[i];

    repeatEachElement = repeatEachElement
      ? repeatEachElement / array.length
      : numberOfCombinations / array.length;

    const everyElementRepeatedLength = repeatEachElement * array.length;

    for (let j = 0; j < numberOfCombinations; j++) {
      const index = Math.floor(
        (j % everyElementRepeatedLength) / repeatEachElement,
      );
      result[j][i] = array[index];
    }
  }

  return result;
};
export const canSignupForServices = (availabilityCheck) => {
  let availability = '';
  if (availabilityCheck !== undefined
    && availabilityCheck !== null
    && availabilityCheck !== []
    && availabilityCheck !== {}) {
    availability = `${availabilityCheck}`.toUpperCase();
  }
  availability += ''; // in case a number is returned
  const afterM = afterMayThisYear(availabilityCheck);
  const IA = isAvailable(availabilityCheck);
  const IPOP = isPartOfCurrentYearPromo(availabilityCheck);
  const twoDigitsAfterM = availability === `${lastYearLast2digits}_${currentYearLast2digits}` && !beforeMay();
  return IA || IPOP || afterM || twoDigitsAfterM;
};
export const simulateClick = (elem) => {
  // Create our event (with options)
  const evt = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  elem.dispatchEvent(evt);
};
export const townCheck = (address) => {
// ifIsDevConsoleLog((APP_URL);
  let townFromAddress = address;
  if (!(address instanceof Array)) {
    townFromAddress = address.split(',');
  }

  if (townFromAddress[1] !== undefined && townFromAddress[1].trim() !== '') {
    const town = townFromAddress[1].trim();
    if (town === 'BEMIDJI') { return [town, 'TURTLE RIVER']; }
    if (town === 'TURTLE RIVER') { return [town, 'BEMIDJI']; }
    if (town === 'PUPOSKY') { return [town, 'NEBISH']; }
    if (town === 'NEBISH') { return [town, 'PUPOSKY']; }
    if (town === 'BLACKDUCK') { return [town, 'FUNKLEY']; }
    if (town === 'FUNKLEY') { return [town, 'BLACKDUCK']; }
    if (town === 'INTERNATIONAL FALLS') { return [town, 'ERICSBURG']; }
    if (town === 'ERICSBURG') { return [town, 'INTERNATIONAL FALLS']; }
  }
  return townFromAddress[1] === undefined ? [] : [townFromAddress[1].trim()];
};
export const addressAbbreviations = (typedAddress) => {
  // ifIsDevConsoleLog(typedAddress);
  const typedUpper = `${typedAddress}`.toUpperCase().trim();
  const addressAndTownSplit = typedUpper.split(',');
  const towns = townCheck(addressAndTownSplit);
  const addressSplit = addressAndTownSplit[0].split(' ');
  const addressArray = [];
  // eslint-disable-next-line no-restricted-syntax
  addressSplit.forEach((value) => {
    let conc = addressAbbreviationsDictionary(value);
    if (!(conc instanceof Array)) {
      conc = [value];
    }
    addressArray.push(conc);
  });
  if (towns.length > 0) { addressArray.push(towns); }
  const combinationResults = allArrayCombinations(addressArray);
  const finalResults = [];
  const union = addressArray.length > 2 ? ',' : '';
  combinationResults.forEach((arrayInIt) => {
    finalResults.push(`${arrayInIt.slice(0, -1).join(' ').trim()}${union} ${arrayInIt.slice(-1)}`);
    finalResults.push(`${arrayInIt.join(' ').trim()}`);
  });
  return finalResults;
};
